import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import "./CancelSaveWidget.scss";
import { AmplitudeEventPropertiesType } from "utils/amplitude";

type CancelSaveWidgetProps = {
  className?: string;
  onClickCancel?: () => void;
  onClickSave?: () => void;
  size?: "xs" | "s" | "m" | "l";
  isSaveDisabled?: boolean;
  saveTextKey?: "save" | "copy" | "move" | "import_section" | "update";
  saveEventName?: string;
  saveEventProps?: Omit<AmplitudeEventPropertiesType, "eventCategory">;
};

export const CancelSaveWidget: FC<CancelSaveWidgetProps> = ({
  onClickCancel,
  onClickSave,
  className,
  isSaveDisabled = false,
  size = "s",
  saveTextKey = "save",
  saveEventName,
  saveEventProps,
}) => {
  return (
    <div className={twMerge("cancel-save-widget flex self-center", className)}>
      {onClickCancel && (
        <LegacyButton
          className="cancel"
          kind="secondary"
          size={size}
          title={t("common.cancel")}
          onClick={onClickCancel}
        >
          {t("common.cancel")}
        </LegacyButton>
      )}
      {onClickSave && (
        <LegacyButton
          className="save"
          disabled={isSaveDisabled}
          eventName={saveEventName}
          eventProperties={saveEventProps}
          kind="primary"
          size={size}
          title={t(`common.${saveTextKey}`)}
          onClick={onClickSave}
        >
          {t(`common.${saveTextKey}`)}
        </LegacyButton>
      )}
    </div>
  );
};
